<div class="response-list-wrapper container">
  @if (responseLists && responseLists.length) {
    <div class="no-selection-state">
      <p class="mat-body">{{ "response-lists.form-responses-text-1" | translate }}</p>
      <p class="mat-body">{{ "response-lists.form-responses-text-2" | translate }}</p>
      <div>
        <button data-test="new-response-list" mat-stroked-button class="primary-button" (click)="openCreateFlyout()">
          <mat-icon>add</mat-icon>
          <span>{{ "response-lists.edit.create" | translate | uppercase }}</span>
        </button>
      </div>
    </div>
    <div class="my-card">
      <app-response-list-selector
        [items]="responseLists"
        [value]="selectedResponseList?.id"
        (selectionChange)="onResponseListSelected($event)"></app-response-list-selector>
      <button
        data-test="edit-response-list-button"
        [disabled]="!this.selectedResponseList"
        mat-stroked-button
        class="gray-button edit-button"
        [matMenuTriggerFor]="editListMenu">
        <i class="material-icons">edit</i>
        <span class="btn-label">
          {{ "response-lists.edit-list-button" | translate }}
          <mat-icon>more_vert</mat-icon>
        </span>
      </button>
      <mat-menu #editListMenu="matMenu">
        <ng-container>
          <button mat-menu-item [disabled]="!selectedResponseList" (click)="openEditFlyout()">
            <div>
              <mat-icon>edit</mat-icon>
              {{ "response-lists.edit-list" | translate }}
            </div>
          </button>
        </ng-container>
        <ng-container>
          <button
            data-test="edit-response-list-button-delete"
            mat-menu-item
            deleteDialog
            deletionType="{{ 'response-lists.response-list' | translate | lowercase }}"
            deletionTypeText="{{ this.selectedResponseList?.name }}"
            deletionTypeHeader="{{ 'confirmationDialog.confirmationTitle' }}"
            deletionText="{{ 'confirmationDialog.delete-message' }}"
            (onDelete)="deleteList()">
            <div>
              <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
              {{ "generic.delete" | translate }} {{ "response-lists.response-list" | translate | lowercase }}
            </div>
          </button>
        </ng-container>
      </mat-menu>
    </div>
    <div>
      <div class="wrapper-charts">
        <div class="charts-tem"><app-response-list-campaigns [responseList]="selectedResponseList"></app-response-list-campaigns></div>
        <div class="charts-tem">
          <app-response-list-responses-bar-chart
            [height]="213"
            [nameChart]="responsesOverTime?.name"
            [dataArray]="responsesOverTime"
            [days]="responsesOverTimeDays"
            [title]="'response-lists.responses-over-time-header'"></app-response-list-responses-bar-chart>
        </div>
      </div>
    </div>
    @if (hasChartData) {
      <div class="info-container">
        @for (columnDefinition of statistics; track columnDefinition; let i = $index) {
          @if (columnDefinition["values"] && columnDefinition["values"].length) {
            <div class="piecharts-container" [ngClass]="i > 2 ? 'hidden-chart' : ''">
              {{ columnDefinition["name"] }}
              <app-response-list-chart [isDarkTheme]="isDarkTheme" [dataArray]="columnDefinition['values']"></app-response-list-chart>
            </div>
          }
        }
      </div>
    }
    @if (statistics?.length > 3 && !isAllChatsShown) {
      <div class="button-wrapper">
        <button mat-stroked-button class="gray-button" (click)="showAllCharts()">
          <span class="btn-label">
            {{ "response-lists.show-all-graphs" | translate | uppercase }}
            <mat-icon>keyboard_arrow_right</mat-icon>
          </span>
        </button>
      </div>
    }
    <!-- Table -->
    @if (selectedResponseList) {
      <app-response-items-table
        [selectedResponseList]="selectedResponseList"
        [customNameMapper]="customNameMapper"
        [responseStatistics]="responseStatistics"></app-response-items-table>
    }
  }

  @if (isLoadingResponseList) {
    <div class="loader">
      <img src="/assets/img/buzz/buzz-loading-anim-lightmode.svg" alt="{{ 'generic.loading' | translate }}" class="loader-anim loader-anim--light" />
      <img src="/assets/img/buzz/buzz-loading-anim-darkmode.svg" alt="{{ 'generic.loading' | translate }}" class="loader-anim loader-anim--dark" />
    </div>
  }

  @if (responseLists && !responseLists.length) {
    <div class="zero-state">
      <app-zero-state-form-response></app-zero-state-form-response>
    </div>
  }
</div>
